// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"111":"8c75c5de","816":"bbec914b"}[chunkId] + ".chunk.css";
};